import { ICalculationResponse } from '../../../../../../../../../../shared/interfaces/IFootprint';
import { IInputMaterial } from '../../PcfWizard.type';

export const calculateEmissionBreakdownValues = (
  calculationResponse?: ICalculationResponse,
): number[] => {
  let materialInputs = 0;
  let energyConsumption = 0;
  let transportation = 0;
  let wasteTreatment = 0;

  calculationResponse?.data.processes?.forEach((process) => {
    materialInputs +=
      process?.input_materials?.reduce((acc: number, material: IInputMaterial) => {
        return acc + (material?.emissions || 0);
      }, 0) || 0;

    energyConsumption += process?.total_machine_emissions || 0;

    transportation += process?.route_calculation?.total_emissions || 0;

    wasteTreatment += process?.waste_management?.emissions || 0;
  });

  return [materialInputs, energyConsumption, transportation, wasteTreatment];
};
